import { useColorScheme } from "@mui/material"
import { routes, useLocation, useMatch, useParams } from "@cedarjs/router"
import { Toaster } from "@cedarjs/web/toast"
import * as Sentry from "@sentry/react"
import { AnimatePresence } from "framer-motion"
// import { Parallax } from "react-parallax"
import app_bg from 'src/assets/app_bg.jpg'
// import app_bg_batch from 'src/assets/app_bg_batch.jpg'
import { useAuth } from "src/auth"
import AnimatedSlidingBlock from "src/components/AnimatedSlidingBlock/AnimatedSlidingBlock"
import SubHeaderBatchCell from "src/components/SubHeaderBatchCell"
import Header from "src/components/Header/Header"
import SubHeaderTankCell from "src/components/SubHeaderTankCell"
import { useDateStore, useStateStore } from "src/lib/store"

type AppLayoutProps = {
  children?: React.ReactNode
}

const AppLayout = ({ children }: AppLayoutProps) => {
  const { idSite, idTank, idBatch } = useParams()
  const location = useLocation()
  const isForecastPage = useMatch(routes.forecast({ idSite: parseInt(idSite) }))
  const isHarvestPage = useMatch(routes.siteHarvest({ idSite: parseInt(idSite) }))
  const isBatchReportPage = useMatch(routes.batchReport({ idSite: parseInt(idSite) }))
  const isBatchHomePage = useMatch(routes.batch({idBatch: parseInt(idBatch)}))
  const isOnBatchRoutes = location.pathname.match(/^\/batch/)
  const isBatchPage = !!isOnBatchRoutes || !!isBatchHomePage.match || !!isForecastPage.match || !!isHarvestPage.match || !!isBatchReportPage.match;
  const currentDate = useDateStore(state => state.getDateForGQL())
  const [tank, site] = useStateStore(state => [state.tank, state.site])
  
  //Get idSite from either url or state, if we're on a batch page without query params
  let _idSite = idSite ? parseInt(idSite) : site?.id;
  const { pathname, search, hash } = useLocation()
  const { currentUser } = useAuth()

  // Add the user id
  React.useEffect(() => {
    // https://matomo.org/faq/tag-manager/how-do-i-set-the-user-id-using-matomo-tag-manager/
    //@ts-expect-error _mtm does exist if configurated well
    currentUser && window._mtm?.push({'uid': currentUser.email });
    //Sentry user setup
    //Ref: https://docs.sentry.io/platforms/javascript/configuration/apis/#setUser
    currentUser && Sentry.setUser({ id:currentUser.id, email: currentUser.email, username: currentUser.fullName});
  }, [currentUser])
  // https://redwoodjs.com/docs/router#uselocation
  // log the URL to Matomo when the pathname changes
  React.useEffect(() => {
    // https://developer.matomo.org/guides/spa-tracking
    if(currentUser)
      //@ts-expect-error _mtm does exist if configurated well
      window._mtm?.push({'event': 'mtm.PageView'});
  }, [pathname, currentUser])
  
  //Prevents auto layout animation glitch if the state of the scroll is preveserved on page change
  const isScrollAtTop = window.scrollY == 0
  
  let _select = null;
  if(!!isHarvestPage.match)
    _select = {path:"harvest", urlSearchString: "idHarvest"};
  else if(!!isBatchHomePage.match)
    _select = {rootPath:"/batch/", urlSearchString: "idBatch"};
  else if(!!isOnBatchRoutes)
    _select = {path:"id", urlSearchString: "idBatch"};

  
  return (
    <div className="relative min-h-screen">
      <div className="absolute bg-top bg-cover -z-50 top-0 left-0 h-full right-0 bottom-0 dark:bg-[#151618] dark:bg-blend-soft-light" style={{ backgroundImage: `url(${app_bg})` }}></div>
      <div className={`top-0 z-50  bg-white/50 dark:bg-dark-950/50 ${!isBatchPage ? "sticky" : "relative"}`}>
        <Header />
        <AnimatePresence mode="wait">
          {idSite && !isBatchPage && <AnimatedSlidingBlock key="tank-cell" layout={isScrollAtTop} slideX={false}><SubHeaderTankCell idSite={Number(idSite)} date={currentDate} canHostBatch={tank ? tank.tank_type.canHostBatch : true}/></AnimatedSlidingBlock>}
          {isBatchPage && <AnimatedSlidingBlock key="batch-cell" layout={isScrollAtTop} slideX={false}><SubHeaderBatchCell idSite={_idSite} select={_select} state={!!isBatchReportPage.match ? "PAST" : null}/></AnimatedSlidingBlock>}
        </AnimatePresence>
      </div>
      {/* <Parallax bgImage={colorScheme == "light" ? (isBatchPage ? app_bg_batch : app_bg) : null} disabled={true} bgImageStyle={{minWidth: "100%"}} strength={600} className={`dark:bg-[#151618] min-w-full ${idSite || isBatchPage ? 'min-h-[calc(100vh-136px)]' : 'min-h-[calc(100vh-80px)]'}`}> */}
        <main className="w-full min-w-full">
          {children}
        </main>
      {/* </Parallax> */}
      <Toaster toastOptions={{ className: 'toaster', duration: 4000, position: "bottom-center" }} />
    </div>
  )
}

export default AppLayout
